import styled from 'styled-components';
export const Spinner = styled.div<{ loading?: string }>`
  width: 24px;
  height: 24px;
  && svg {
    width: 100%;
    height: 100%;
    margin: 0;
  }
  ${({ loading }) => loading == 'true' && `animation: spin 0.5s linear infinite`};
`;
